// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"496":"graphql-print","557":"f10664bc"}[chunkId] || chunkId) + "." + {"496":"83edc8afc0370428","505":"cc9fc12025c4fd75","557":"1efa5216adf15a0f","571":"496f88a42b9259fe"}[chunkId] + ".js";
};